import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Select, Tooltip } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { useLocation, useHistory } from "react-router-dom";
import qs from "qs";
import articleStore from "@app/state/store/report/article";

import "./style/file-selector.scoped.scss";

const { Option } = Select;

const FileSelector = observer(({ article, viewState }) => {
    const location = useLocation();
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const history = useHistory();

    useEffect(() => {
        if (params.snippet && article.supplementaryFiles?.length > 0) {
            const highlightId = params.snippet;
            const highlight = articleStore.highlights.find((hl) => hl._id === highlightId);

            if (highlight?.fileId) {
                viewState.selectedFileId = highlight.fileId;
            } else if (article.file) {
                viewState.selectedFileId = article.file;
            }
        } else if (article.file) {
            viewState.selectedFileId = article.file;
        }
    }, [params.snippet, article, viewState, articleStore.highlights]);

    if (!article.file) {
        return null;
    }

    const hasSupplementaryFiles = article.supplementaryFiles?.length > 0;

    if (!hasSupplementaryFiles && viewState.view === "file") {
        return null;
    }

    const handleChange = (value) => {
        viewState.selectedFileId = value;
        history.push(location.pathname + "?view-file=true");
    };

    return (
        <>
            {hasSupplementaryFiles && (
                <div className="file-selector">
                    <Tooltip title="Supplementary Data">
                        <Select
                            value={viewState.selectedFileId || article.file}
                            onChange={handleChange}
                            style={{ width: 300 }}
                            dropdownClassName="file-selector-dropdown"
                        >
                            <Option value={article.file}>
                                <FileTextOutlined /> (Article) {`${article.title}`}
                            </Option>
                            {article.supplementaryFiles.map((file) => (
                                <Option key={file._id} value={file._id}>
                                    <FileTextOutlined /> {file.name}
                                </Option>
                            ))}
                        </Select>
                    </Tooltip>
                </div>
            )}
        </>
    );
});

export default FileSelector;
